import React from 'react';
import Menu from './Menu'; // Assurez-vous que le chemin est correct
import '../CSS/CommunMenu.css'; // Assurez-vous que le chemin est correct

const CommunMenu = ({ children }) => {
  return (
    <div className="container">
      <Menu />
      <div className="main-content">
        {children}
      </div>
    </div>
  );
};

export default CommunMenu;
